import ContactSplit from "../components/sections/ContactSplit";
import { MaskedLine } from "../components/MaskedLine";

export default function ContactPage() {
  return (
    <main data-testid="page-contact">
      <section className="ground-paper pt-[104px] pb-10 md:pt-[132px] md:pb-14">
        <div className="wrap max-w-[1100px]">
          <div className="flex items-center gap-4 mb-10">
            <span className="series-stamp"><span>Contact</span></span>
            <span className="stamp-dim">Response within 24 hours</span>
          </div>
          <h1 className="h-hero" style={{ fontSize: "clamp(48px, 8vw, 128px)" }}>
            <MaskedLine>Send</MaskedLine>
            <MaskedLine delay={0.1}>the <span className="claim">brief.</span></MaskedLine>
          </h1>
          <p className="aside mt-10 max-w-[640px]">
            The studio takes on a limited number of organisations each quarter. Every requirement gets a personal reply — no auto-responder, no BDR.
          </p>
        </div>
      </section>
      <ContactSplit />
    </main>
  );
}
